<template>
  <el-container id="glSceneSon">
    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">
      <div style="display:flex;white-space: nowrap;">
        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} ></p>
        <p style="color:#000000;line-height:0.3;margin-left:5px;font-weight: bold;">{{ h_text }}</p>
      </div>
    </el-header>
    <el-container class="main_glSceneSon">
      <el-main style="background: #FFFFFF;padding-bottom:60px">
        <p style="font-size:25px;margin-left:25px;font-weight:bold;">{{ h_text }}</p>
        <div style="display:flex;justify-content:left;align-items:center;margin-left:40px">
            <span style="width:80px; margin-left:10px; color: #000000; font-size: 13px">
               联动名称：
            </span>
          <el-input
            placeholder="请输入联动名称"
            style="width:25vw;"
            clearable
            v-model="ld_name">
          </el-input>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               联动描述：
            </span>
          <el-input
            placeholder="请输入联动描述"
            style="width:25vw;"
            clearable
            v-model="ld_ms">
          </el-input>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
          <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               所属区域：
          </span>
          <el-select v-model="edi_buildId" ref='select1'
                     filterable placeholder="楼栋" @change="getFloor('build')"
                     style="width:5vw;">
            <el-option
              v-for="item in li_build"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--          <el-select v-else v-model="edi_buildId" ref='select1' @click.native="getBuilding()"-->
          <!--                     clearable filterable placeholder="楼栋"-->
          <!--                     style="width:5vw;">-->
          <!--            <el-option-->
          <!--              v-for="item in li_build"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-select v-model="edi_floorId" ref='select2' @change="getFloor('floor')"
                     @click.native="checkLd()"
                     clearable filterable placeholder="楼层"
                     style="width:5vw;margin-left:10px">
            <el-option
              v-for="item in li_floor"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--          <el-select v-else v-model="edi_floorId" ref='select2' @change="getFloor('floor')"-->
          <!--                     clearable filterable placeholder="楼层" @click.native="checkLd()"-->
          <!--                     style="width:5vw;margin-left:10px">-->
          <!--            <el-option-->
          <!--              v-for="item in li_floor"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <el-select v-model="edi_roomId" ref='select3' @click.native="checkLd"
                     clearable filterable placeholder="房间"
                     style="width:5vw;margin-left:10px">
            <el-option
              v-for="item in li_room"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--          <el-select v-else v-model="edi_roomId" ref='select3'-->
          <!--                     clearable filterable placeholder="房间"-->
          <!--                     style="width:5vw;margin-left:10px">-->
          <!--            <el-option-->
          <!--              v-for="item in li_room"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               执行周期：
            </span>
          <el-checkbox-group v-model="check_rqS" @change="checksChange(check_rqS)"
                             style="margin-top:6px">
            <el-checkbox v-for="city in rqS" :label="city" :key="city">{{ city }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               触发条件：
            </span>
          <el-button @click="addTjcf" type="primary" plain>添加</el-button>
        </div>
        <div v-for="(tab,ite) in li_tjcf_xz" :key=ite
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:130px">
          <el-select v-model="tab.edi_tjcf" ref='select4' @click.native="onSelectTjcf"
                     clearable filterable placeholder="请选择场景"
                     style="width:25vw;">
            <el-option
              v-for="item in li_tjcf"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--          <el-select v-else v-model="tab.edi_tjcf" ref='select4' @click.native="onSelectTjcf"-->
          <!--                     clearable filterable placeholder="请选择场景"-->
          <!--                     style="width:25vw;">-->
          <!--            <el-option-->
          <!--              v-for="item in li_tjcf"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <i @click="delTjcf(tab.id)" class="el-icon-circle-close"
             style="font-size:20px;color:red;margin-left:15px"></i>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               约束条件：
            </span>
          <el-button @click="addTjys" type="primary" plain>添加</el-button>
        </div>
        <div v-for="(tab,ite) in li_tjys_xz" :key=ite+100
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:130px">
          <el-select v-model="tab.edi_tjys" ref='select5' @click.native="onSelectTjys"
                     clearable filterable placeholder="请选择场景"
                     style="width:25vw;">
            <el-option
              v-for="item in li_tjys"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--          <el-select v-else v-model="tab.edi_tjys" ref='select5' @click.native="onSelectTjys"-->
          <!--                     clearable filterable placeholder="请选择场景"-->
          <!--                     style="width:25vw;">-->
          <!--            <el-option-->
          <!--              v-for="item in li_tjys"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <i @click="delTjys(tab.id)" class="el-icon-circle-close"
             style="font-size:20px;color:red;margin-left:15px"></i>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               例外时段：
            </span>
          <el-button @click="addTjtime" type="primary" plain>添加</el-button>
        </div>
        <div v-for="(tab,ite) in li_tjtime_xz" :key=ite+200
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:130px">
          <el-select v-model="tab.edi_tjtime" ref='select6' @click.native="onSelectTjtime"
                     clearable filterable placeholder="请选择场景"
                     style="width:25vw;">
            <el-option
              v-for="item in li_tjtime"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--          <el-select v-else v-model="tab.edi_tjtime" ref='select6' @click.native="onSelectTjtime"-->
          <!--                     clearable filterable placeholder="请选择场景"-->
          <!--                     style="width:25vw;">-->
          <!--            <el-option-->
          <!--              v-for="item in li_tjtime"-->
          <!--              :key="item.value"-->
          <!--              :label="item.label"-->
          <!--              :value="item.value">-->
          <!--            </el-option>-->
          <!--          </el-select>-->
          <i @click="delTjtime(tab.id)" class="el-icon-circle-close"
             style="font-size:20px;color:red;margin-left:15px"></i>
        </div>
        <div style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:40px">
            <span style="width:80px;margin-left:10px; color: #000000; font-size: 13px">
               执行场景：
            </span>
          <el-button @click="addScene" type="primary" plain>添加</el-button>
        </div>
        <div v-for="(tab,ite) in li_scene_xz" :key=ite+300
             style="display:flex;justify-content:left;align-items:center;margin-top:15px;margin-left:130px">
          <el-select v-model="tab.edi_scene" ref='select4' @click.native="onSelectscene"
                     clearable filterable placeholder="请选择场景"
                     style="width:25vw;">
            <el-option
              v-for="item in li_scene"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <i @click="delScene(tab.id)" class="el-icon-circle-close"
             style="font-size:20px;color:red;margin-left:15px"></i>
        </div>
        <div
          style="display:flex;justify-content:left;align-items:center;margin-top:30px;margin-left:130px">
          <el-button @click="onBack" size="medium">取消</el-button>
          <el-button @click="onKeep" size="medium" type="primary">保存</el-button>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import CryptoJS from 'crypto-js';

export default {
  name:"glSceneSon",
  computed:{},
  data(){
    return {
      h_text:"新增联动",
      li_h_text:[
        {"text":"节能策略","colour":"#B7B7B7","pages":""},
        {"text":"联动策略","colour":"#B7B7B7","pages":""}
      ],
      isCtr:true,
      pageTjcf:1,
      pageSizeTjcf:30,
      totalTjcf:30,
      pageTjys:1,
      pageSizeTjys:30,
      totalTjys:30,
      pageTjtime:1,
      pageSizeTjtime:30,
      totalTjtime:30,
      pageScene:1,
      pageSizeScene:30,
      totalScene:30,
      ld_name:"",
      ld_ms:"",
      isArea:true,
      isTjcf:false,
      edi_tjcf:"",
      li_tjcf:[],
      li_tjcf_xz:[],
      isTjys:false,
      edi_tjys:"",
      li_tjys:[],
      li_tjys_xz:[],
      isTjtime:false,
      edi_tjtime:"",
      li_tjtime:[],
      li_tjtime_xz:[],
      isScene:false,
      edi_scene:"",
      li_scene:[],
      li_scene_xz:[],
      li_build:[],
      edi_buildId:"",
      li_floor:[],
      edi_floorId:"",
      li_room:[],
      edi_roomId:"",
      rqS:[
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "日"
      ],
      check_rqS:[
        "一",
        "二",
        "三",
        "四",
        "五"
      ],
      checkAll:false,
      isIndeterminate:false,
      scen_img:require('@/assets/device1.png'),
      dev_img:require('@/assets/device.png'),
      tab_xz:'手动触发',
      tab_start_dev:[
        {id:1,dev:"触发设备",act:"触发属性"}
      ],
      tab_end_dev:[
        {id:1,dev:"触发设备",act:"触发属性"}
      ],
      value1:[
        new Date(2016,9,10,8,40),
        new Date(2016,9,10,9,40)
      ],
      id:"",
      edi_auth:"",
      li_auth:[],
      SceneName:"",
      passWd:"",
      nickName:"" /*账号*/
    };
  },
  methods:{ /*方法存放*/
    onSelectTjcf(){
      console.log("点击下拉框触发");
      this.getTjcf();
    },
    onSelectTjys(){
      console.log("点击下拉框触发");
      this.getTjys();
    },
    onSelectTjtime(){
      console.log("点击下拉框触发");
      this.getTjtime();
    },
    onSelectscene(){
      console.log("点击下拉框触发");
      this.getScene();
    },
    addTjcf(){
      if(this.li_tjcf_xz.length > 0) {
        this.li_tjcf_xz.push({
          id:this.li_tjcf_xz[this.li_tjcf_xz.length - 1]["id"] + 1,
          edi_tjcf:""
        });
      } else {
        this.li_tjcf_xz.push({
          id:0,
          edi_tjcf:""
        });
      }
    },
    delTjcf(id){
      const index = this.li_tjcf_xz.findIndex(item => item.id === id);
      this.li_tjcf_xz.splice(index,1);
    },
    addTjys(){
      if(this.li_tjys_xz.length > 0) {
        this.li_tjys_xz.push({
          id:this.li_tjys_xz[this.li_tjys_xz.length - 1]["id"] + 1,
          edi_tjys:""
        });
      } else {
        this.li_tjys_xz.push({
          id:0,
          edi_tjys:""
        });
      }
    },
    delTjys(id){
      const index = this.li_tjys_xz.findIndex(item => item.id === id);
      this.li_tjys_xz.splice(index,1);
    },
    addTjtime(){
      if(this.li_tjtime_xz.length > 0) {
        this.li_tjtime_xz.push({
          id:this.li_tjtime_xz[this.li_tjtime_xz.length - 1]["id"] + 1,
          edi_tjtime:""
        });
      } else {
        this.li_tjtime_xz.push({
          id:0,
          edi_tjtime:""
        });
      }
    },
    delTjtime(id){
      const index = this.li_tjtime_xz.findIndex(item => item.id === id);
      this.li_tjtime_xz.splice(index,1);
    },
    addScene(){
      if(this.li_scene_xz.length > 0) {
        this.li_scene_xz.push({
          id:this.li_scene_xz[this.li_scene_xz.length - 1]["id"] + 1,
          edi_scene:""
        });
      } else {
        this.li_scene_xz.push({
          id:0,
          edi_scene:""
        });
      }
    },
    delScene(id){
      const index = this.li_scene_xz.findIndex(item => item.id === id);
      this.li_scene_xz.splice(index,1);
    },
    onXz(){
      console.log(this.tab_xz);
    },
    checksChange(val){
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.rqS.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.rqS.length;
    },
    handleSelectMenu(path){ /*左侧导航栏事件*/
      console.log(path);
      this.$router.push({path:path}); /*路由跳转*/
    },
    show_change(item){
      if(item) {
        this.$refs.select.focus();
      } else {
        this.$refs.select.blur();
      }
    },
    show_change1(item){
      if(item) {
        this.$refs.select1.focus();
      } else {
        this.$refs.select1.blur();
      }
    },
    show_change2(item){
      if(item) {
        this.$refs.select2.focus();
      } else {
        this.$refs.select2.blur();
      }
    },
    show_change3(item){
      if(item) {
        this.$refs.select3.focus();
      } else {
        this.$refs.select3.blur();
      }
    },
    onKeep(){
      if(this.isCtr) {
        this.isCtr = false;
        if(this.h_text === '新增联动') {
          this.addScene1();
        } else {
          this.changeScene();
        }
        setTimeout(() => {
          this.isCtr = true;
        },600);
      }
    },
    get_zq(zq){
      let j = 0;
      if(zq.includes("日")) {
        j += 1;
      }
      if(zq.includes("一")) {
        j += 2;
      }
      if(zq.includes("二")) {
        j += 4;
      }
      if(zq.includes("三")) {
        j += 8;
      }
      if(zq.includes("四")) {
        j += 16;
      }
      if(zq.includes("五")) {
        j += 32;
      }
      if(zq.includes("六")) {
        j += 64;
      }
      return j;
    },
    addScene1(){
      const params = {
        'name':this.ld_name,
        'description':this.ld_ms, // 描述
        "cycle":0,
        'enable':true,
        'roomId':this.edi_roomId,
        'trigger':[],
        'condition':[],
        'exception':[],
        'scene':[],
        'projectId':localStorage.getItem("projectId")
      };
      if(this.check_rqS.length > 0) {
        params['cycle'] = this.get_zq(this.check_rqS);
      }
      console.log(this.li_tjcf_xz);
      for(let i = 0; i < this.li_tjcf_xz.length; i++) {
        params["trigger"].push({
          "id":this.li_tjcf_xz[i]["edi_tjcf"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      for(let i = 0; i < this.li_tjys_xz.length; i++) {
        params["condition"].push({
          "id":this.li_tjys_xz[i]["edi_tjys"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      for(let i = 0; i < this.li_tjtime_xz.length; i++) {
        params["exception"].push({
          "id":this.li_tjtime_xz[i]["edi_tjtime"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      for(let i = 0; i < this.li_scene_xz.length; i++) {
        params["scene"].push({
          "id":this.li_scene_xz[i]["edi_scene"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.addAuto,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("添加联动成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("添加联动失败");
        }
      });
    },
    changeScene(){
      const params = {
        'id':this.id,
        'name':this.ld_name,
        'description':this.ld_ms, // 描述
        "cycle":0,
        'enable':true,
        'roomId':this.edi_roomId,
        'trigger':[],
        'condition':[],
        'exception':[],
        'scene':[],
        'projectId':localStorage.getItem("projectId")
      };
      if(this.check_rqS.length > 0) {
        params['cycle'] = this.get_zq(this.check_rqS);
      }
      console.log(this.li_tjcf_xz);
      for(let i = 0; i < this.li_tjcf_xz.length; i++) {
        params["trigger"].push({
          "id":this.li_tjcf_xz[i]["edi_tjcf"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      for(let i = 0; i < this.li_tjys_xz.length; i++) {
        params["condition"].push({
          "id":this.li_tjys_xz[i]["edi_tjys"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      for(let i = 0; i < this.li_tjtime_xz.length; i++) {
        params["exception"].push({
          "id":this.li_tjtime_xz[i]["edi_tjtime"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      for(let i = 0; i < this.li_scene_xz.length; i++) {
        params["scene"].push({
          "id":this.li_scene_xz[i]["edi_scene"],
          "projectId":localStorage.getItem("projectId")
        });
      }
      const headers = {
        'token':localStorage.getItem("token")
      };
      console.log(params);
      this.$api.post(this.$urls.ip + this.$urls.updateAuto,params,headers).then(res => {
        console.log(res.data.data);
        this.$message.success("修改成功");
        this.$router.go(-1);
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("修改失败");
        }
      });
    },
    onBack(){
      this.$router.go(-1);
    },
    getTjcf(){
      if(this.pageTjcf <= this.totalTjcf / this.pageSizeTjcf + 1) {
        const params = {
          'page':this.pageTjcf,
          'pageSize':this.pageSizeTjcf,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.getAutoTriggerList,params,headers).then(res => {
          console.log(res.data.data);
          this.totalTjcf = res.data.data["total"];
          let l_d = [];
          if(this.isTjcf) {
            l_d = this.li_tjcf;
          }
          let li_d = res.data.data["list"];
          for(let i = 0; i < li_d.length; i++) {
            let d = {
              value:li_d[i]['id'],
              label:li_d[i]['name']
            };
            l_d.push(d);
          }
          this.li_tjcf = l_d;
          this.isTjcf = true;
          this.pageTjcf += 1;
          this.getTjcf();
        }).catch(error => {
          console.log(error);
          if(error) {
            this.$message.error("获取触发条件失败");
          }
        });
      }
    },
    getTjys(){
      if(this.pageTjys <= this.totalTjys / this.pageSizeTjys + 1) {
        const params = {
          'page':this.pageTjys,
          'pageSize':this.pageSizeTjys,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.getAutoConditionList,params,headers).then(res => {
          console.log(res.data.data);
          this.totalTjys = res.data.data["total"];
          let l_d = [];
          if(this.isTjys) {
            l_d = this.li_tjys;
          }
          let li_d = res.data.data["list"];
          for(let i = 0; i < li_d.length; i++) {
            let d = {
              value:li_d[i]['id'],
              label:li_d[i]['name']
            };
            l_d.push(d);
          }
          this.li_tjys = l_d;
          this.isTjys = true;
          this.pageTjys += 1;
          this.getTjys();
        }).catch(error => {
          console.log(error);
          if(error) {
            this.$message.error("获取触发条件失败");
          }
        });
      }
    },
    getTjtime(){
      if(this.pageTjtime <= this.totalTjtime / this.pageSizeTjtime + 1) {
        const params = {
          'page':this.pageTjtime,
          'pageSize':this.pageSizeTjtime,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.getAutoExceptionList,params,headers).then(res => {
          console.log(res.data.data);
          this.totalTjtime = res.data.data["total"];
          let l_d = [];
          if(this.isTjtime) {
            l_d = this.li_tjtime;
          }
          let li_d = res.data.data["list"];
          for(let i = 0; i < li_d.length; i++) {
            let d = {
              value:li_d[i]['id'],
              label:li_d[i]['name']
            };
            l_d.push(d);
          }
          this.li_tjtime = l_d;
          this.isTjtime = true;
          this.pageTjtime += 1;
          this.getTjtime();
        }).catch(error => {
          console.log(error);
          if(error) {
            this.$message.error("获取触发条件失败");
          }
        });
      }
    },
    getScene(){
      if(this.pageScene <= this.totalScene / this.pageSizeScene + 1) {
        const params = {
          'page':this.pageScene,
          'all':true,
          'pageSize':this.pageSizeScene,
          'projectId':localStorage.getItem("projectId")
        };
        const headers = {
          'token':localStorage.getItem("token")
        };
        this.$api.post(this.$urls.ip + this.$urls.getSceneList,params,headers).then(res => {
          console.log(res.data.data);
          this.totalScene = res.data.data["total"];
          let l_d = [];
          if(this.isScene) {
            l_d = this.li_scene;
          }
          let li_d = res.data.data["list"];
          for(let i = 0; i < li_d.length; i++) {
            let d = {
              value:li_d[i]['id'],
              label:li_d[i]['name']
            };
            d['roomName'] = "";
            d['floorName'] = "";
            d['buildName'] = "";
            if(li_d[i]['room']) {
              d['roomName'] = li_d[i]['room']['name'];
              d['floorId'] = li_d[i]['room']['floorId'];
              if(li_d[i]['room']['floor']) {
                d['floorName'] = li_d[i]['room']['floor']['name'];
                d['buildId'] = li_d[i]['room']['floor']['buildingId'];
                if(li_d[i]['room']['floor']['building']) {
                  d['buildName'] = li_d[i]['room']['floor']['building']['name'];
                }
              }
            }
            d["label"] = li_d[i]['name'] + ` (${d['buildName']}/${d['floorName']}/${d['roomName']})`;
            l_d.push(d);
          }
          this.li_scene = l_d;
          this.isScene = true;
          this.pageScene += 1;
          this.getScene();
        }).catch(error => {
          console.log(error);
          if(error) {
            this.$message.error("获取触发条件失败");
          }
        });
      }
    },
    initView(area_type = ""){
      let isCleanF = true;
      let isCleanR = true;
      let l = [];
      let l_d = this.li_buildInfo;
      for(let i = 0; i < l_d.length; i++) {
        let d = {
          value:l_d[i]['id'],
          label:l_d[i]['name']
        };
        if(this.edi_floorId === l_d[i]['id']) {
          isCleanF = false;
        }
        l.push(d);
      }
      this.li_floor = l;
      l = [];
      for(let j = 0; j < l_d.length; j++) {
        if(this.edi_floorId && l_d[j]['id'] !== this.edi_floorId) {
          continue;
        }
        for(let k = 0; k < l_d[j]['rooms'].length; k++) {
          let d = {
            value:l_d[j]['rooms'][k]['id'],
            label:l_d[j]['rooms'][k]['name']
          };
          if(this.edi_roomId === l_d[j]['rooms'][k]['id']) {
            isCleanR = false;
          }
          l.push(d);
        }
      }
      if(isCleanF) {
        this.edi_floorId = "";
      }
      if(isCleanR) {
        this.edi_roomId = "";
      }
      this.li_room = l;
    },
    initZq(cycle){
      this.check_rqS = [];
      let zq = parseInt(cycle).toString(2);
      var paddingLength = 7 - zq.length;
      for(let i = 0; i < paddingLength; i++) {
        zq = '0' + zq;
      }
      if(zq[5].includes("1")) {
        this.check_rqS.push("一");
      }
      if(zq[4].includes("1")) {
        this.check_rqS.push("二");
      }
      if(zq[3].includes("1")) {
        this.check_rqS.push("三");
      }
      if(zq[2].includes("1")) {
        this.check_rqS.push("四");
      }
      if(zq[1].includes("1")) {
        this.check_rqS.push("五");
      }
      if(zq[0].includes("1")) {
        this.check_rqS.push("六");
      }
      if(zq[6].includes("1")) {
        this.check_rqS.push("日");
      }
    },
    checkLd(){
      if(!this.edi_buildId) {
        this.$message.info("请先选择楼栋");
      }
    },
    getFloor(area_type = ""){
      const params = {
        "page":1,
        "pageSize":1000,
        "id":this.li_area[this.item]['id'],
        "projectId":localStorage.getItem("projectId")
      };
      if(area_type === "build") {
        if(this.edi_buildId) {
          params["id"] = this.edi_buildId;
          const headers = {
            'token':localStorage.getItem("token")
          };
          console.log(params);
          this.$api.post(this.$urls.ip + this.$urls.getBuildingInfo,params,headers).then(res => {
            console.log("楼栋信息：",res.data.data);
            this.li_buildInfo = res.data.data["floors"];
            this.initView(area_type);
          }).catch(error => {
            console.log(error);
            if(error) {
              this.$message.error("获取楼层数据失败");
            }
          });
        }
      } else if(area_type === "floor") {
        this.initView(area_type);
      }
    },
    getBuilding(){
      const params = {
        "page":1,
        "pageSize":1000,
        "projectId":localStorage.getItem("projectId")
      };
      const headers = {
        'token':localStorage.getItem("token")
      };
      this.$api.post(this.$urls.ip + this.$urls.getBuildingList,params,headers).then(res => {
        console.log(res.data.data);
        this.li_area = res.data.data.list;
        let l_d = this.li_area;
        let l = [];
        for(let i = 0; i < l_d.length; i++) {
          let d = {
            value:l_d[i]['id'],
            label:l_d[i]['name']
          };
          l.push(d);
        }
        this.li_build = l;
        this.item = 0;
        this.getFloor("build");
      }).catch(error => {
        console.log(error);
        if(error) {
          this.$message.error("获取区域失败");
        }
      });
    }
  },
  mounted(){ /*页面加载时调用*/
    const value = this.$route.query.key;
    console.log(value);
    if(value === "add") {
      this.h_text = "新增联动";
    } else {
      console.log(value);
      this.h_text = "修改联动信息";
      this.id = parseInt(this.$route.query.id);
      this.ld_name = this.$route.query.name;
      this.ld_ms = this.$route.query.description;
      this.edi_roomId = parseInt(this.$route.query.roomId);
      this.edi_floorId = parseInt(this.$route.query.floorId);
      this.edi_buildId = parseInt(this.$route.query.buildId);
      this.li_room.push({
        value:this.edi_roomId,
        label:this.$route.query.roomName
      });
      this.li_floor.push({
        value:this.edi_floorId,
        label:this.$route.query.floorName
      });
      this.li_build.push({
        value:this.edi_buildId,
        label:this.$route.query.buildName
      });
      this.initZq(this.$route.query.cycle);
      let li_tjcf_xz = JSON.parse(this.$route.query.trigger);
      for(let i = 0; i < li_tjcf_xz.length; i++) {
        this.li_tjcf.push({
          value:li_tjcf_xz[i]['edi_tjcf'],
          label:li_tjcf_xz[i]['name']
        });
      }
      this.li_tjcf_xz = li_tjcf_xz;
      let li_tjys_xz = JSON.parse(this.$route.query.condition);
      for(let i = 0; i < li_tjys_xz.length; i++) {
        this.li_tjys.push({
          value:li_tjys_xz[i]['edi_tjys'],
          label:li_tjys_xz[i]['name']
        });
      }
      this.li_tjys_xz = li_tjys_xz;
      let li_tjtime_xz = JSON.parse(this.$route.query.exception);
      for(let i = 0; i < li_tjtime_xz.length; i++) {
        this.li_tjtime.push({
          value:li_tjtime_xz[i]['edi_tjtime'],
          label:li_tjtime_xz[i]['name']
        });
      }
      this.li_tjtime_xz = li_tjtime_xz;
      let li_scene_xz = JSON.parse(this.$route.query.scene);
      for(let i = 0; i < li_scene_xz.length; i++) {
        this.li_scene.push({
          value:li_scene_xz[i]['edi_scene'],
          label:li_scene_xz[i]['name']
        });
      }
      this.li_scene_xz = li_scene_xz;
    }
    this.getBuilding();
  },
  beforeDestroy(){ /*页面结束时调用*/

  }
};
</script>

<style>
#glSceneSon {
  height: 100vh;
  margin: 0;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 0;
  background: #F4F4F4;
}

.main_glSceneSon {
  background: #F4F4F4;
  height: auto;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/scene/sceneTlinkSon.vue